import { Button, ButtonProps, styled } from '@mui/material';

interface SidebarButtonLink {
  isSidebarOpen?: boolean;
  isActive?: boolean;
}

interface forHover {
  color: string;
  background?: string;
}

const SidebarButtonLinkWrapper = <C extends React.ElementType>(
  props: ButtonProps<C, { component?: C }> & SidebarButtonLink,
) => <Button {...props}>{props.children}</Button>;

export const SidebarButtonLink = styled(SidebarButtonLinkWrapper, {
  shouldForwardProp: (prop) => prop !== 'isSidebarOpen' && prop !== 'isActive',
})(({ theme, isSidebarOpen, isActive }) => {
  const hoverCss: forHover = {
    color: isActive ? theme.palette.primary.contrastText : theme.palette.text.secondary,
  };
  if (isActive) {
    hoverCss.background = theme.palette.primary.main;
  }
  return {
    alignSelf: isSidebarOpen ? 'flex-start' : 'center',
    justifyContent: isSidebarOpen ? 'flex-start' : 'center',
    padding: theme.spacing(1, 1.5),
    textTransform: 'capitalize',
    height: theme.spacing(5),
    minWidth: theme.spacing(5),
    width: isSidebarOpen ? '100%' : theme.spacing(4),
    color: isActive ? theme.palette.primary.contrastText : theme.palette.text.primary,
    background: isActive ? theme.palette.primary.light : theme.palette.primary.contrastText,
    fontWeight: isActive ? 500 : theme.typography.fontWeightRegular,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    '&:hover': hoverCss,
    '& .MuiButton-startIcon': {
      ...(!isSidebarOpen && { margin: '0' }),
    },
    '& svg': {
      '& path': {
        fill: isActive ? theme.palette.primary.contrastText : theme.palette.grey[500],
      },
      width: 24,
      height: 24,
    },
  };
});
